import React, { useCallback, useState } from 'react';
import Modal from '../components/ui/Modal';

/**
 * Confirmação no visual do app, no lugar de `window.confirm`.
 *
 * O confirm nativo era usado em Insumos, Usuarios e PainelLavoura. Além de
 * quebrar a identidade visual, ele bloqueia a thread e, num PWA instalado,
 * aparece com o nome do domínio — o que dá aparência de site, não de aplicativo.
 *
 * Uso:
 *   const { confirmar, ConfirmDialog } = useConfirm();
 *   ...
 *   if (await confirmar({ titulo: 'Excluir?', mensagem: '...' })) apagar();
 *   ...
 *   return <>{ConfirmDialog}...</>;
 */
export function useConfirm() {
  const [pedido, setPedido] = useState(null);

  const confirmar = useCallback((opcoes) => new Promise((resolve) => {
    setPedido({ ...opcoes, resolve });
  }), []);

  const responder = (valor) => {
    pedido?.resolve(valor);
    setPedido(null);
  };

  const ConfirmDialog = pedido ? (
    <Modal titulo={pedido.titulo || 'Confirmar'} onClose={() => responder(false)} largura={420}>
      <p style={{ fontSize: '0.9rem', lineHeight: 1.6, color: 'var(--text)' }}>
        {pedido.mensagem}
      </p>
      {pedido.aviso && (
        <p style={{ fontSize: '0.82rem', lineHeight: 1.5, color: 'var(--danger-dark)', marginTop: '0.75rem' }}>
          {pedido.aviso}
        </p>
      )}
      <div className="actions" style={{ marginTop: '1.25rem', justifyContent: 'flex-end' }}>
        <button type="button" className="btn-secondary" onClick={() => responder(false)}>
          {pedido.labelCancelar || 'Cancelar'}
        </button>
        <button
          type="button"
          className={pedido.perigo === false ? 'btn-primary' : 'btn-danger'}
          onClick={() => responder(true)}
        >
          {pedido.labelConfirmar || 'Confirmar'}
        </button>
      </div>
    </Modal>
  ) : null;

  return { confirmar, ConfirmDialog };
}
